/*
 * Copyright (c) 2020  Apricad LLC. All Rights Reserved.
 */

import * as React from "react";
import { renderRoutes } from "react-router-config";

import { fetchUser } from "./actions/user";

import "assets/css/apricot.css";
import { HeaderLinks } from "components/Header/HeaderLinks";
import { Toast } from "components/Modal/Toast";

interface Props {
  route: any;
  headerRoutes: any;
  footerRoutes: any;
  // [x: string]: any;
}

const AppBase: React.FC<Props> = ({
  route,
  headerRoutes,
  footerRoutes,
}: Props) => {
  // any routes matched in matchRoutes, will be passed in as an object

  return (
    <>
      {renderRoutes(headerRoutes, {
        // These are the props for Header
        links: HeaderLinks,
        color: "transparent",
        changeColorOnScroll: {
          height: 120,
          color: "white",
        },
      })}
      {renderRoutes(route.routes)}
      {renderRoutes(footerRoutes)}
      <Toast />
    </>
  );
};

export default {
  component: AppBase,

  // loadData is called by index.js of RS, with parameter 'store'. We only need
  // to return the result of fetchUser
  loadData: (store: any) => store.dispatch(fetchUser()), // return a promise
};
